<style></style>
<template>
  <div id="app">
    <div class="flex h-screen overflow-hidden bg-gray-100 ">
      <div
        class="relative w-full overflow-x-hidden overflow-y-scroll bg-gray-50"
      >
        <div
          class="hidden sm:block sm:absolute sm:inset-y-0 sm:h-full sm:w-full"
        >
          <div class="relative h-full max-w-screen-xl mx-auto">
            <svg
              class="absolute transform right-full lg:translate-x-1/2"
              width="404"
              height="784"
              fill="none"
              viewBox="0 0 404 784"
            >
              <defs>
                <pattern
                  id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    class="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="404"
                height="784"
                fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
              />
            </svg>
            <svg
              class="absolute transform left-full -translate-y-3/4 -translate-x-1/4 md:-translate-y-1/2 lg:-translate-x-1/2"
              width="404"
              height="784"
              fill="none"
              viewBox="0 0 404 784"
            >
              <defs>
                <pattern
                  id="5d0dd344-b041-4d26-bec4-8d33ea57ec9b"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    class="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="404"
                height="784"
                fill="url(#5d0dd344-b041-4d26-bec4-8d33ea57ec9b)"
              />
            </svg>
          </div>
        </div>

        <div
          class="relative h-full pt-6 pb-12 sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32"
        >
          <div class="max-w-screen-lg px-4 mx-auto sm:px-6">
            <nav class="relative sm:h-10 ">
              <div class="">
                <div class="flex items-center justify-between w-full md:w-auto">
                  <div class="w-2/12">
                    <div class="space-y-1" v-if="languages.length > 1">
                      <div class="relative">
                        <span class="inline-block rounded-md shadow-sm">
                          <button
                            @click="toogleLangMenu"
                            type="button"
                            aria-haspopup="listbox"
                            aria-expanded="true"
                            aria-labelledby="listbox-label"
                            class="relative w-full py-1.5 pl-3 pr-6 text-left transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md cursor-default focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                          >
                            <div class="flex items-center space-x-2">
                              <img
                                :src="
                                  'https://static.menubyte.it/icons/flags/' +
                                    this.$store.state.locale +
                                    '.svg'
                                "
                                class="w-6 h-6 rounded-full"
                              />
                              <span class="hidden sm:inline-block">{{
                                this.$store.state.locale
                              }}</span>
                            </div>
                            <span
                              class="absolute inset-y-0 right-0 flex items-center pr-1 pointer-events-none"
                            >
                              <svg
                                class="w-5 h-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span>
                          </button>
                        </span>

                        <!-- Select popover, show/hide based on select state. -->
                        <div
                          v-click-outside="onClickOutsideLang"
                          v-if="isOpenLang"
                          class="absolute w-full mt-1 bg-white rounded-md shadow-lg"
                          style="width:200px"
                        >
                          <ul
                            tabindex="-1"
                            role="listbox"
                            aria-labelledby="listbox-label"
                            aria-activedescendant="listbox-item-3"
                            class="py-1 overflow-auto text-base leading-6 rounded-md shadow-xs max-h-56 focus:outline-none sm:text-sm sm:leading-5"
                          >
                            <li
                              @click="setLang(lang.code)"
                              v-for="lang in languages"
                              :key="lang.id"
                              :value="lang.code"
                              role="option"
                              class="relative py-2 pl-3 text-gray-900 cursor-default select-none pr-9"
                            >
                              <div class="flex items-center space-x-2">
                                <img
                                  :src="
                                    'https://static.menubyte.it/icons/flags/' +
                                      lang.code +
                                      '.svg'
                                  "
                                  class="flex-shrink-0 w-6 h-6 rounded-full"
                                />
                                <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
                                <span class="block font-normal truncate">
                                  {{ lang.code }}
                                </span>
                              </div>

                              <!--
                          Checkmark, only display for selected option.

                          Highlighted: "text-white", Not Highlighted: "text-indigo-600"
                        -->
                              <span
                                class="absolute inset-y-0 right-0 flex items-center pr-4"
                                v-if="lang.code == $store.state.locale"
                              >
                                <svg
                                  class="w-5 h-5"
                                  :class="'text-' + $store.state.color.primary"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd"
                                  />
                                </svg>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="w-8/12 ">
                    <router-link
                      :to="{
                        name: 'Home',
                        params: { uuid: $store.state.location.uuid },
                      }"
                      :aria-label="$store.state.location.name"
                      class="block text-center"
                    >
                      <img
                        v-if="$store.state.location.logo"
                        class="w-auto mx-auto h-14 "
                        :src="getLogo($store.state.location.logo)"
                        :alt="$store.state.location.name"
                      />
                      <h2 v-else>{{ $store.state.location.name }}</h2>
                    </router-link>
                  </div>
                  <div class="w-2/12 text-right">
                    <div class="flex items-center justify-end -mr-2">
                      <button
                        @click="toogleMobileMenu"
                        type="button"
                        class="inline-flex items-center justify-center p-2 text-gray-400 transition duration-150 ease-in-out rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500"
                        id="main-menu"
                        aria-label="Main menu"
                        aria-haspopup="true"
                      >
                        <svg
                          class="w-6 h-6"
                          stroke="currentColor"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 6h16M4 12h16M4 18h16"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </div>

          <!--
      Mobile menu, show/hide based on menu open state.

      Entering: "duration-150 ease-out"
        From: "opacity-0 scale-95"
        To: "opacity-100 scale-100"
      Leaving: "duration-100 ease-in"
        From: "opacity-100 scale-100"
        To: "opacity-0 scale-95"
    -->
          <transition
            appear
            enter-active-class="duration-150 ease-out"
            enter-class="scale-95 opacity-0"
            enter-to-class="scale-100 opacity-100"
            leave-active-class="duration-100 ease-in"
            leave-class="scale-100 opacity-100"
            leave-to-class="scale-95 opacity-0"
          >
            <div
              v-if="isOpenMobile"
              class="absolute inset-x-0 top-0 z-10 max-w-screen-lg p-2 mx-auto transition origin-top-right transform"
              v-click-outside="onClickOutsideMobile"
            >
              <div class="rounded-lg shadow-md">
                <div
                  class="overflow-hidden bg-white rounded-lg shadow-xs"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="main-menu"
                >
                  <div class="flex items-center justify-between px-5 pt-4">
                    <div class="flex items-center">
                      <img
                        v-if="$store.state.location.logo"
                        class="w-auto h-10 mx-auto sm:h-10"
                        :src="getLogo($store.state.location.logo)"
                        :alt="$store.state.location.name"
                      />
                      <h2 class="ml-2">{{ $store.state.location.name }}</h2>
                    </div>
                    <div class="-mr-2">
                      <button
                        @click="toogleMobileMenu"
                        type="button"
                        class="inline-flex items-center justify-center p-2 text-gray-400 transition duration-150 ease-in-out rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500"
                        aria-label="Close menu"
                      >
                        <svg
                          class="w-6 h-6"
                          stroke="currentColor"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <div class="px-2 pt-2 pb-3">
                    <a
                      v-if="$store.state.location.phone"
                      :href="'tel:' + $store.state.location.phone"
                      class="block px-3 py-2 text-base font-medium text-gray-700 transition duration-150 ease-in-out rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50"
                      role="menuitem"
                    >
                      <div class="flex items-center">
                        <svg
                          class="w-5 h-5 mr-2 fill-current "
                          :class="'text-' + $store.state.color.primary"
                          height="512"
                          viewBox="0 0 512.021 512.021"
                          width="512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M367.988 512.021c-16.528 0-32.916-2.922-48.941-8.744-70.598-25.646-136.128-67.416-189.508-120.795S34.389 263.572 8.744 192.974c-8.241-22.688-10.673-46.108-7.226-69.612 3.229-22.016 11.757-43.389 24.663-61.809 12.963-18.501 30.245-33.889 49.977-44.5C97.2 5.738 120.167 0 144.423 0a16.002 16.002 0 0115.645 12.647l25.114 117.199a16.004 16.004 0 01-4.331 14.667l-42.913 42.912c40.482 80.486 106.17 146.174 186.656 186.656l42.912-42.913a16.01 16.01 0 0114.667-4.331l117.199 25.114a16 16 0 0112.647 15.645c0 24.256-5.738 47.224-17.054 68.266-10.611 19.732-25.999 37.014-44.5 49.977-18.419 12.906-39.792 21.434-61.809 24.663a142.318 142.318 0 01-20.668 1.519zM131.639 32.7c-31.995 3.532-60.393 20.302-79.251 47.217-21.206 30.265-26.151 67.49-13.567 102.132C88.125 317.775 194.246 423.896 329.972 473.2c34.641 12.584 71.866 7.64 102.132-13.567 26.915-18.858 43.685-47.256 47.217-79.251l-95.341-20.43-44.816 44.816a15.998 15.998 0 01-18.117 3.168c-95.19-44.72-172.242-121.772-216.962-216.962a15.999 15.999 0 013.168-18.117l44.816-44.816z"
                          />
                        </svg>
                        <span>{{ $t("phone") }}</span>
                      </div>
                    </a>

                    <a
                      v-if="$store.state.location.facebook"
                      target="_blank"
                      :href="
                        $store.state.location.facebook.startsWith('http')
                          ? $store.state.location.facebook
                          : 'http://' + $store.state.location.facebook
                      "
                      class="block px-3 py-2 text-base font-medium text-gray-700 transition duration-150 ease-in-out rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50"
                      role="menuitem"
                    >
                      <div class="flex items-center">
                        <svg
                          class="w-5 h-5 mr-2 fill-current "
                          :class="'text-' + $store.state.color.primary"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path
                            d="M452 0H60C26.916 0 0 26.916 0 60v392c0 33.084 26.916 60 60 60h392c33.084 0 60-26.916 60-60V60c0-33.084-26.916-60-60-60zm20 452c0 11.028-8.972 20-20 20H338V309h61.79L410 247h-72v-43c0-16.975 13.025-30 30-30h41v-62h-41c-50.923 0-91.978 41.25-91.978 92.174V247H216v62h60.022v163H60c-11.028 0-20-8.972-20-20V60c0-11.028 8.972-20 20-20h392c11.028 0 20 8.972 20 20v392z"
                          />
                        </svg>
                        <span>Facebook</span>
                      </div>
                    </a>

                    <a
                      v-if="$store.state.location.instagram"
                      target="_blank"
                      :href="
                        $store.state.location.instagram.startsWith('http')
                          ? $store.state.location.instagram
                          : 'http://' + $store.state.location.instagram
                      "
                      class="block px-3 py-2 text-base font-medium text-gray-700 transition duration-150 ease-in-out rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50"
                      role="menuitem"
                    >
                      <div class="flex items-center">
                        <svg
                          class="w-5 h-5 mr-2 fill-current "
                          :class="'text-' + $store.state.color.primary"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path
                            d="M352 0H160C71.648 0 0 71.648 0 160v192c0 88.352 71.648 160 160 160h192c88.352 0 160-71.648 160-160V160C512 71.648 440.352 0 352 0zm112 352c0 61.76-50.24 112-112 112H160c-61.76 0-112-50.24-112-112V160C48 98.24 98.24 48 160 48h192c61.76 0 112 50.24 112 112v192z"
                          />
                          <path
                            d="M256 128c-70.688 0-128 57.312-128 128s57.312 128 128 128 128-57.312 128-128-57.312-128-128-128zm0 208c-44.096 0-80-35.904-80-80 0-44.128 35.904-80 80-80s80 35.872 80 80c0 44.096-35.904 80-80 80z"
                          />
                          <circle cx="393.6" cy="118.4" r="17.056" />
                        </svg>
                        <span>Instagram</span>
                      </div>
                    </a>

                    <a
                      v-if="$store.state.location.whatsapp"
                      target="_blank"
                      :href="$store.state.location.whatsapp"
                      class="block px-3 py-2 text-base font-medium text-gray-700 transition duration-150 ease-in-out rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50"
                      role="menuitem"
                    >
                      <div class="flex items-center">
                        <svg
                          class="w-5 h-5 mr-2 fill-current "
                          :class="'text-' + $store.state.color.primary"
                          height="512"
                          viewBox="0 0 24 24"
                          width="512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.507 14.307l-.009.075c-2.199-1.096-2.429-1.242-2.713-.816-.197.295-.771.964-.944 1.162-.175.195-.349.21-.646.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.77-1.66-2.07-.293-.506.32-.578.878-1.634.1-.21.049-.375-.025-.524-.075-.15-.672-1.62-.922-2.206-.24-.584-.487-.51-.672-.51-.576-.05-.997-.042-1.368.344-1.614 1.774-1.207 3.604.174 5.55 2.714 3.552 4.16 4.206 6.804 5.114.714.227 1.365.195 1.88.121.574-.091 1.767-.721 2.016-1.426.255-.705.255-1.29.18-1.425-.074-.135-.27-.21-.57-.345z"
                          />
                          <path
                            d="M20.52 3.449C12.831-3.984.106 1.407.101 11.893c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652c7.905 4.27 17.661-1.4 17.665-10.449 0-3.176-1.24-6.165-3.495-8.411zm1.482 8.417c-.006 7.633-8.385 12.4-15.012 8.504l-.36-.214-3.75.975 1.005-3.645-.239-.375c-4.124-6.565.614-15.145 8.426-15.145a9.865 9.865 0 017.021 2.91 9.788 9.788 0 012.909 6.99z"
                          />
                        </svg>
                        <span>Whatsapp</span>
                      </div>
                    </a>

                    <a
                      v-if="$store.state.location.website"
                      target="_blank"
                      :href="
                        $store.state.location.website.startsWith('http')
                          ? $store.state.location.website
                          : 'http://' + $store.state.location.website
                      "
                      class="block px-3 py-2 text-base font-medium text-gray-700 transition duration-150 ease-in-out rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50"
                      role="menuitem"
                    >
                      <div class="flex items-center">
                        <svg
                          class="w-5 h-5 mr-2 fill-current "
                          :class="'text-' + $store.state.color.primary"
                          height="512"
                          viewBox="0 0 512 512"
                          width="512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M437.02 74.98C388.667 26.628 324.38 0 256 0S123.333 26.628 74.98 74.98 0 187.62 0 256s26.628 132.667 74.98 181.02S187.62 512 256 512s132.667-26.628 181.02-74.98S512 324.38 512 256s-26.628-132.667-74.98-181.02zm-2.132 315.679c-15.31-10.361-31.336-19.314-47.952-26.789 7.339-28.617 11.697-59.688 12.784-91.87h79.702c-3.144 44.336-19.244 85.147-44.534 118.659zM32.578 272h79.702c1.088 32.183 5.446 63.254 12.784 91.87-16.616 7.475-32.642 16.427-47.952 26.789-25.29-33.512-41.39-74.323-44.534-118.659zm44.53-150.654c15.31 10.362 31.336 19.315 47.954 26.79-7.338 28.615-11.695 59.683-12.783 91.864H32.578c3.144-44.334 19.243-85.142 44.53-118.654zm283.519-42.581c-5.863-10.992-12.198-20.911-18.935-29.713 27.069 11.25 51.473 27.658 71.977 47.997a286.931 286.931 0 01-36.155 20.185c-4.886-13.664-10.528-26.547-16.887-38.469zm-12.965 50.404C318.451 138.961 287.623 144 256 144s-62.451-5.039-91.662-14.831C184.801 70.916 218.611 32 256 32s71.199 38.916 91.662 97.169zM144.303 240c1.056-28.342 4.885-55.421 10.937-80.116C187.376 170.528 221.258 176 256 176s68.624-5.472 100.76-16.116c6.053 24.695 9.881 51.773 10.937 80.116zm223.394 32c-1.057 28.344-4.885 55.424-10.938 80.12C324.62 341.474 290.739 336 256 336s-68.62 5.474-100.759 16.12c-6.053-24.696-9.882-51.776-10.938-80.12zM151.373 78.765c-6.358 11.922-12 24.805-16.887 38.468a286.876 286.876 0 01-36.155-20.185c20.503-20.34 44.907-36.747 71.977-47.997-6.737 8.803-13.073 18.722-18.935 29.714zm-16.886 316.008c4.886 13.661 10.528 26.542 16.885 38.462 5.863 10.992 12.198 20.911 18.935 29.713-27.067-11.25-51.469-27.655-71.971-47.992a287.08 287.08 0 0136.151-20.183zm29.853-11.938C193.553 373.041 224.38 368 256 368s62.447 5.041 91.66 14.835C327.197 441.086 293.388 480 256 480s-71.197-38.914-91.66-97.165zm196.287 50.4c6.357-11.92 11.999-24.801 16.885-38.462a287.065 287.065 0 0136.151 20.183c-20.502 20.337-44.904 36.743-71.971 47.992 6.737-8.802 13.073-18.721 18.935-29.713zM399.72 240c-1.088-32.18-5.445-63.249-12.783-91.864 16.618-7.475 32.645-16.428 47.954-26.79 25.287 33.511 41.386 74.319 44.53 118.654z"
                          />
                        </svg>
                        <span>{{ $t("website") }}</span>
                      </div>
                    </a>
                  </div>
                  <div v-if="$store.state.location.marketing_feedback_settings">
                    <router-link
                      :class="'text-' +
                          $store.state.color.primary +
                          ' bg-' +
                          $store.state.color.secondary
                      "
                      :to="{ name: 'Review' }"
                      class="block w-full px-5 py-3 font-medium text-center transition duration-150 ease-in-out focus:outline-none"
                      role="menuitem"
                    >
                      <span>{{ $t("ctareview") }}</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <main
            class="max-w-screen-lg px-4 mx-auto mt-10 sm:px-6 lg:mt-10 xl:mt-10"
          >
            <router-view :key="$route.path" />

            <div
              v-if="
                $store.state.location.marketing_email_settings &&
                  $store.state.location.marketing_email_settings.enable == 1
              "
            >
              <div class="max-w-screen-xl pt-12 pb-6 mx-auto">
                <div
                  :class="'bg-' + $store.state.color.secondary"
                  class="px-4 py-4 rounded-lg shadow md:py-12 md:px-12 lg:py-16 lg:px-16 xl:flex xl:items-center"
                >
                  <div class="xl:w-0 xl:flex-1">
                    <h2
                      :class="'text-' + $store.state.color.primary"
                      class="text-xl font-extrabold leading-8 tracking-tight sm:text-2xl sm:leading-9"
                    >
                      {{ $t("newsletter.title") }}
                    </h2>
                    <p
                      v-if="
                        $store.state.location.marketing_email_settings
                          .coupon_enable
                      "
                      :class="'text-' + $store.state.color.primary"
                      class="max-w-3xl text-base leading-6"
                      id="newsletter-headline"
                    >
                      {{
                        $t("newsletter.coupon", {
                          value:
                            $store.state.location.marketing_email_settings
                              .coupon_value,
                        })
                      }}
                    </p>
                  </div>
                  <div class="mt-2 sm:w-full sm:max-w-md xl:mt-0 xl:ml-8">
                    <form v-on:submit.prevent="onSubmit">
                      <div v-if="!formNewsletterResponse">
                        <div
                          class="sm:flex"
                          aria-labelledby="newsletter-headline"
                        >
                          <input
                            v-model="formNewsletter.email"
                            aria-label="email"
                            type="email"
                            required
                            class="w-full px-5 py-3 text-base leading-6 text-gray-900 placeholder-gray-500 transition duration-150 ease-in-out bg-white border border-transparent rounded-md appearance-none focus:outline-none focus:placeholder-gray-400"
                            placeholder="email"
                          />
                          <div
                            class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0"
                          >
                            <button
                              :class="'bg-' + $store.state.color.primary"
                              type="submit"
                              class="flex items-center justify-center w-full px-5 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out border border-transparent rounded-md focus:outline-none"
                            >
                              {{ $t("newsletter.subscribe") }}
                            </button>
                          </div>
                        </div>
                        <div class="relative flex items-start mt-2">
                          <div class="absolute flex items-center h-5">
                            <input
                              required
                              v-model="formNewsletter.privacy"
                              id="pp"
                              type="checkbox"
                              class="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                            />
                          </div>
                          <div class="text-sm leading-5 pl-7">
                            <label
                              for="pp"
                              class="font-medium text-gray-900"
                              v-html="
                                $t('newsletter.privacy', {
                                  value: this.privacy,
                                })
                              "
                            ></label>
                          </div>
                        </div>
                      </div>
                      <div
                        v-else
                        class="p-2 mt-4 text-xs text-green-500 bg-white rounded-lg"
                      >
                        {{ formNewsletterResponse }}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="fixed bottom-2 right-2 lg:right-6 h-14"
              v-show="dishes.length > 0"
            >
              <button
                @click="toogleSlide"
                type="button"
                class="inline-flex items-center w-20 h-12 px-3 py-2 text-sm font-medium leading-4 text-white transition duration-150 ease-in-out border border-gray-400 rounded-full shadow-md focus:outline-none focus:border-gray-400 focus:shadow-outline-gray"
                :class="'bg-' + $store.state.color.primary"
              >
                <svg
                  class="w-6 h-6 ml-1 text-white fill-current"
                  height="512"
                  viewBox="0 0 24 24"
                  width="512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.894 24a.5.5 0 01-.491-.597l.707-3.535a.49.49 0 01.137-.256l7.778-7.778a1.503 1.503 0 012.121 0l1.414 1.414a1.501 1.501 0 010 2.121l-7.778 7.778a.497.497 0 01-.256.137l-3.535.707a.53.53 0 01-.097.009zm1.168-3.789l-.53 2.651 2.651-.53 7.671-7.671a.5.5 0 000-.707L21.44 12.54a.5.5 0 00-.707 0zm2.367 2.582h.01zM9.5 21h-7A2.502 2.502 0 010 18.5v-13C0 4.121 1.121 3 2.5 3h2a.5.5 0 010 1h-2C1.673 4 1 4.673 1 5.5v13c0 .827.673 1.5 1.5 1.5h7a.5.5 0 010 1zM16.5 12a.5.5 0 01-.5-.5v-6c0-.827-.673-1.5-1.5-1.5h-2a.5.5 0 010-1h2C15.879 3 17 4.121 17 5.5v6a.5.5 0 01-.5.5z"
                  />
                  <path
                    d="M11.5 6h-6C4.673 6 4 5.327 4 4.5v-2a.5.5 0 01.5-.5h1.55C6.282.86 7.293 0 8.5 0s2.218.86 2.45 2h1.55a.5.5 0 01.5.5v2c0 .827-.673 1.5-1.5 1.5zM5 3v1.5c0 .275.225.5.5.5h6c.275 0 .5-.225.5-.5V3h-1.5a.5.5 0 01-.5-.5C10 1.673 9.327 1 8.5 1S7 1.673 7 2.5a.5.5 0 01-.5.5zM13.5 9h-10a.5.5 0 010-1h10a.5.5 0 010 1zM13.5 12h-10a.5.5 0 010-1h10a.5.5 0 010 1zM13.5 15h-10a.5.5 0 010-1h10a.5.5 0 010 1z"
                  />
                </svg>
                <span class="flex-1 text-center">
                  {{ countDish }}
                </span>
              </button>
            </div>

            <transition
              appear
              enter-active-class="duration-500 ease-in-out"
              enter-class="opacity-0"
              enter-to-class="opacity-100"
              leave-active-class="duration-500 ease-in-out"
              leave-class="opacity-100"
              leave-to-class="opacity-0"
            >
              <div class="fixed inset-0 overflow-hidden" v-show="slideVisible">
                <div class="absolute inset-0 overflow-hidden">
                  <div
                    @click="toggleSlide()"
                    class="absolute inset-0 transition-opacity bg-gray-500 bg-opacity-75"
                  ></div>
                  <transition
                    appear
                    enter-active-class="transition duration-500 ease-in-out transform sm:duration-700"
                    enter-class="translate-x-full"
                    enter-to-class="translate-x-0"
                    leave-active-class="transition duration-500 ease-in-out transform sm:duration-700"
                    leave-class="translate-x-0"
                    leave-to-class="translate-x-full"
                  >
                    <section
                      class="absolute inset-y-0 right-0 flex max-w-full pl-10"
                      v-show="slideVisible"
                    >
                      <div class="w-screen max-w-md">
                        <div
                          v-show="orderStep === 2"
                          class="flex flex-col h-full py-6 space-y-6 overflow-y-scroll bg-white shadow-xl"
                        >
                          <header class="px-4 sm:px-6">
                            <div
                              class="flex items-start justify-between space-x-3"
                            >
                              <h2
                                class="text-lg font-medium leading-7 text-gray-900"
                              >
                                {{ $t("cart.order_method") }}
                              </h2>

                              <div class="flex items-center h-7">
                                <button
                                  @click="toogleSlide"
                                  aria-label="Close panel"
                                  class="text-gray-400 transition duration-150 ease-in-out hover:text-gray-500"
                                >
                                  <svg
                                    class="w-6 h-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M6 18L18 6M6 6l12 12"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </header>
                          <div class="relative flex-1 px-4 sm:px-6">
                            <div
                              v-for="orderType in avaibleOrderTypes"
                              :key="orderType.id"
                            >
                              <label class="block">
                                <input
                                  type="radio"
                                  name="orderType"
                                  v-model="selectedOrderType"
                                  :value="orderType.order_type[0].slug"
                                />
                                {{ orderType.order_type[0].name }}
                                <span
                                  v-if="
                                    orderType.settings.shippingFee &&
                                      orderType.settings.shippingFree &&
                                      orderType.settings.shippingFee > 0 &&
                                      countDishNoPrice == 0 &&
                                      total > orderType.settings.shippingFree
                                  "
                                  >({{ $t("cart.free_delivery") }})
                                </span>
                                <span v-else-if="orderType.settings.shippingFee"
                                  >(+{{
                                    orderType.settings.shippingFee
                                  }}€)</span
                                >

                                <span
                                  class="block ml-4 text-xs"
                                  v-if="orderType.settings.notes"
                                  >{{ orderType.settings.notes }}</span
                                >
                              </label>
                            </div>

                            <div
                              v-if="
                                (selectedOrderType == 'domicilio' ||
                                  selectedOrderType == 'asporto') &&
                                  this.$store.state.location.opening_hours !=
                                    null
                              "
                            >
                              <p
                                class="mt-3 text-sm"
                                v-html="$t('cart.alert_opening_hours')"
                              ></p>
                              <div
                                class="px-4 py-2 mt-2 text-sm bg-gray-100 divide-y-2 divide-gray-200 rounded-sm shadow-sm divide-dotted"
                              >
                                <div
                                  v-for="key in Object.keys(
                                    this.$store.state.location.opening_hours
                                  )"
                                  :key="key"
                                >
                                  <span class=""> {{ getDayName(key) }}:</span>
                                  <span
                                    v-for="day in $store.state.location
                                      .opening_hours[key]"
                                    :key="day.id"
                                  >
                                    {{ getTimeSpan(day) }}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div v-if="selectedOrderType == 'domicilio'">
                              <div class="pt-6 pb-5 space-y-6">
                                <div class="">
                                  <div class="flex flex-wrap -mx-2">
                                    <div class="w-1/2 px-2">
                                      <label
                                        for="delivery_name"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.delivery_day") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <date-picker
                                          format="DD-MM-YYYY"
                                          :default-value="new Date()"
                                          :disabled-date="disabledDateDelivery"
                                          v-model="delivery.date"
                                          :lang="lang"
                                          id="delivery_name"
                                          class="block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                        ></date-picker>
                                      </div>
                                    </div>
                                    <div class="w-1/2 px-2">
                                      <label
                                        for="delivery_time_slot"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.delivery_hours") }}*
                                      </label>
                                      <div
                                        class="relative max-w-full rounded-md shadow-sm"
                                      >
                                        <date-picker
                                          v-model="delivery.time_slot"
                                          :time-picker-options="{
                                            start: '07:30',
                                            step: '00:15',
                                            end: '23:45',
                                          }"
                                          format="HH:mm"
                                          type="time"
                                          placeholder="HH:mm"
                                        ></date-picker>

                                        <!--
                              <input  v-model="delivery.time_slot" id="delivery_time_slot" class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5">
                              -->
                                      </div>
                                    </div>
                                    <div class="w-1/2 px-2 mt-3">
                                      <label
                                        for="delivery_name"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.name") }}
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.name
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.name"
                                          id="delivery_name"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                    <div class="w-1/2 px-2 mt-3">
                                      <label
                                        for="delivery_surname"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.surname") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.surname
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.surname"
                                          id="delivery_surname"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                    <div class="w-1/2 px-2 mt-3">
                                      <label
                                        for="delivery_phone"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.phone") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.phone
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.phone"
                                          id="delivery_phone"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                    <div class="w-1/2 px-2 mt-3">
                                      <label
                                        for="delivery_email"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.email") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.email
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.email"
                                          id="delivery_email"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                    <div class="w-2/3 px-2 mt-3">
                                      <label
                                        for="delivery_city"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.city") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.city
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.city"
                                          id="delivery_city"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                    <div class="w-1/3 px-2 mt-3">
                                      <label
                                        for="delivery_zip"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.zip") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.zip
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.zip"
                                          id="delivery_zip"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                    <div class="w-2/3 px-2 mt-3">
                                      <label
                                        for="delivery_street"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.street") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.street
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.street"
                                          id="delivery_street"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                    <div class="w-1/3 px-2 mt-3">
                                      <label
                                        for="delivery_house_number"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.house_number") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.house_number
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.house_number"
                                          id="delivery_house_number"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                    <div class="w-full px-2 mt-3">
                                      <label
                                        for="delivery_note"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.delivery_note") }}
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <textarea
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.delivery_note
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.delivery_note"
                                          id="delivery_note"
                                          rows="4"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        ></textarea>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="selectedOrderType == 'asporto'">
                              <div class="pt-6 pb-5 space-y-6">
                                <div class="">
                                  <div class="flex flex-wrap -mx-2">
                                    <div class="w-1/2 px-2">
                                      <label
                                        for="delivery_name"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.delivery_day") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <date-picker
                                          format="DD-MM-YYYY"
                                          :default-value="new Date()"
                                          :disabled-date="disabledDateTakeAway"
                                          v-model="delivery.date"
                                          :lang="lang"
                                          id="delivery_name"
                                          class="block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                        ></date-picker>
                                      </div>
                                    </div>
                                    <div class="w-1/2 px-2">
                                      <label
                                        for="delivery_time_slot"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.delivery_hours") }}*
                                      </label>
                                      <div
                                        class="relative max-w-full rounded-md shadow-sm"
                                      >
                                        <date-picker
                                          v-model="delivery.time_slot"
                                          :time-picker-options="{
                                            start: '07:30',
                                            step: '00:15',
                                            end: '23:45',
                                          }"
                                          format="HH:mm"
                                          type="time"
                                          placeholder="HH:mm"
                                        ></date-picker>

                                        <!--
                              <input  v-model="delivery.time_slot" id="delivery_time_slot" class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5">
                              -->
                                      </div>
                                    </div>
                                    <div class="w-1/2 px-2 mt-3">
                                      <label
                                        for="delivery_name"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.name") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.name
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.name"
                                          id="delivery_name"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                    <div class="w-1/2 px-2 mt-3">
                                      <label
                                        for="delivery_surname"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.surname") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.surname
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.surname"
                                          id="delivery_surname"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                    <div class="w-1/2 px-2 mt-3">
                                      <label
                                        for="delivery_phone"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.phone") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.phone
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.phone"
                                          id="delivery_phone"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                    <div class="w-1/2 px-2 mt-3">
                                      <label
                                        for="delivery_email"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.email") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.email
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.email"
                                          id="delivery_email"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="selectedOrderType == 'tavolo'">
                              <div class="pt-6 pb-5 space-y-6">
                                <div class="">
                                  <div class="flex flex-wrap -mx-2">
                                    <div class="w-1/2 px-2 mt-3">
                                      <label
                                        for="table_name"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.table_name") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.table_name
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.table_name"
                                          id="table_name"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>

                                    <div
                                      class="w-1/2 px-2 mt-3"
                                      v-if="table.requirePassword"
                                    >
                                      <label
                                        for="delivery_password"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.password") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.password
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.password"
                                          id="delivery_password"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="selectedOrderType == 'umbrella'">
                              <div class="pt-6 pb-5 space-y-6">
                                <div class="">
                                  <div class="flex flex-wrap -mx-2">
                                    <div class="w-1/2 px-2 mt-3">
                                      <label
                                        for="umbrella_name"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.umbrella_name") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.table_name
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.table_name"
                                          id="table_name"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>

                                    <div
                                      class="w-1/2 px-2 mt-3"
                                      v-if="umbrella.requirePassword"
                                    >
                                      <label
                                        for="delivery_password"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.password") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.password
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.password"
                                          id="delivery_password"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="selectedOrderType == 'tavolo-hotel'">
                              <div class="pt-6 pb-5 space-y-6">
                                <div class="">
                                  <div class="flex flex-wrap -mx-2">
                                    <p>{{ $t("cart.attention") }}</p>
                                    <ul class="list-disc list-inside">
                                      <li>{{ $t("cart.attention_1") }}</li>
                                      <li>{{ $t("cart.attention_2") }}</li>
                                    </ul>
                                    <div class="w-1/2 px-2 mt-3">
                                      <label
                                        for="room"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.room_number") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.room
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.room"
                                          id="room"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>

                                    <div
                                      class="w-1/2 px-2 mt-3"
                                      v-if="hotel.requirePassword"
                                    >
                                      <label
                                        for="delivery_password"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.password") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.password
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.password"
                                          id="delivery_password"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="selectedOrderType == 'roomservice'">
                              <div class="pt-6 pb-5 space-y-6">
                                <div class="">
                                  <div class="flex flex-wrap -mx-2">
                                    <div class="w-1/2 px-2">
                                      <label
                                        for="delivery_name"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.delivery_day") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <date-picker
                                          format="DD-MM-YYYY"
                                          :default-value="new Date()"
                                          :disabled-date="
                                            disabledDateRoomService
                                          "
                                          v-model="delivery.date"
                                          :lang="lang"
                                          id="delivery_name"
                                          class="block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                        ></date-picker>
                                      </div>
                                    </div>
                                    <div
                                      class="w-1/2 px-2"
                                      v-if="roomservice.selectedOrderHour"
                                    >
                                      <label
                                        for="delivery_time_slot"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.delivery_hours") }}*
                                      </label>
                                      <div
                                        class="relative max-w-full rounded-md shadow-sm"
                                      >
                                        <date-picker
                                          v-model="delivery.time_slot"
                                          :time-picker-options="{
                                            start: '00:00',
                                            step: '00:15',
                                            end: '23:45',
                                          }"
                                          format="HH:mm"
                                          type="time"
                                          placeholder="HH:mm"
                                        ></date-picker>

                                        <!--
                              <input  v-model="delivery.time_slot" id="delivery_time_slot" class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5">
                              -->
                                      </div>
                                    </div>
                                    <div class="w-1/2 px-2">
                                      <label
                                        for="table_name"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.room_number") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.room
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.room"
                                          id="table_name"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>

                                    <div
                                      class="w-1/2 px-2"
                                      v-if="roomservice.requirePassword"
                                    >
                                      <label
                                        for="delivery_password"
                                        class="block text-sm font-medium leading-5 text-gray-900"
                                      >
                                        {{ $t("cart.password") }}*
                                      </label>
                                      <div
                                        class="relative rounded-md shadow-sm"
                                      >
                                        <input
                                          :class="
                                            delivery.errors &&
                                            delivery.errors.password
                                              ? 'border-red-300'
                                              : ''
                                          "
                                          v-model="delivery.password"
                                          id="delivery_password"
                                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="
                                delivery.errors != null &&
                                  Object.keys(delivery.errors).length > 0
                              "
                            >
                              <p>{{ $t("fix_validation_errors") }}:</p>
                              <div class="px-2 py-2 bg-red-200 rounded-md">
                                <p
                                  class="text-sm"
                                  v-for="errorKey in Object.keys(
                                    delivery.errors
                                  )"
                                  :key="errorKey"
                                >
                                  {{ delivery.errors[errorKey][0] }}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            v-show="selectedOrderType != null"
                            class="flex-shrink-0 px-4 pt-6 border-t border-gray-200 sm:px-6"
                          >
                            <div class="flex justify-end space-x-3">
                              <span class="inline-flex rounded-md shadow-sm">
                                <button
                                  @click="goToStep(1)"
                                  type="button"
                                  class="px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800"
                                >
                                  {{ $t("back") }}
                                </button>
                              </span>
                              <span class="inline-flex rounded-md shadow-sm">
                                <button
                                  :disabled="isDisabled"
                                  @click="submitDeliveryOrder()"
                                  :class="' text-' +
                                      $store.state.color.secondary +
                                      ' bg-' +
                                      $store.state.color.primary
                                  "
                                  class="inline-flex items-center px-4 py-2 text-base font-medium leading-6 transition duration-150 ease-in-out border border-transparent rounded-md focus:outline-none focus:shadow-outline-indigo"
                                >
                                  <svg
                                    v-if="spinOn"
                                    class="w-5 h-5 mr-3 -ml-1 text-white animate-spin"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                  >
                                    <circle
                                      class="opacity-25"
                                      cx="12"
                                      cy="12"
                                      r="10"
                                      stroke="currentColor"
                                      stroke-width="4"
                                    ></circle>
                                    <path
                                      class="opacity-75"
                                      fill="currentColor"
                                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                  </svg>
                                  {{ $t("cart.order_now") }}
                                </button>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div
                          v-show="orderStep === 1"
                          class="flex flex-col h-full py-6 space-y-6 overflow-y-scroll bg-white shadow-xl"
                        >
                          <header class="px-4 sm:px-6">
                            <div
                              class="flex items-start justify-between space-x-3"
                            >
                              <h2
                                class="text-lg font-medium leading-7 text-gray-900"
                              >
                                {{ $t("cart.order") }}
                              </h2>

                              <div class="flex items-center h-7">
                                <button
                                  @click="toogleSlide"
                                  aria-label="Close panel"
                                  class="text-gray-400 transition duration-150 ease-in-out hover:text-gray-500"
                                >
                                  <svg
                                    class="w-6 h-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M6 18L18 6M6 6l12 12"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </header>
                          <div class="relative flex-1 px-4 sm:px-6">
                            <div
                              class="pb-2 mb-2 border-b border-dotted"
                              v-for="group in dishesGrouppedByMenu"
                              :key="group.id"
                            >
                              <div
                                class="mb-1 text-lg"
                                :class="'text-' + $store.state.color.primary"
                              >
                                {{ group.menu.menuname }}
                                <span
                                  v-if="group.menu.menudate"
                                  class="text-base text-black"
                                >
                                  del
                                  <span class="underline">{{
                                    group.menu.menudate
                                  }}</span></span
                                >
                              </div>

                              <div class="ml-2 space-y-3">
                                <div
                                  v-for="dish in group.dishes"
                                  :key="dish.id"
                                >
                                  <div>
                                    {{
                                      get(
                                        dish.translations,
                                        $store.state.locale,
                                        "name"
                                      )
                                    }}
                                  </div>

                                  <div class="flex flex-wrap justify-between">
                                    <div class="flex items-center">
                                      <button @click="removeQuantity(dish)">
                                        <svg
                                          class="w-6 h-6 fill-current "
                                          :class="'text-' + $store.state.color.primary
                                          "
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 512 512"
                                        >
                                          <g data-name="Raggruppa 2">
                                            <g data-name="Raggruppa 1">
                                              <path
                                                data-name="Tracciato 1"
                                                d="M256 0C114.833 0 0 114.833 0 256s114.833 256 256 256 256-114.853 256-256S397.167 0 256 0zm0 472.341C136.725 472.341 39.659 375.3 39.659 256S136.725 39.659 256 39.659 472.341 136.705 472.341 256 375.3 472.341 256 472.341z"
                                              />
                                            </g>
                                          </g>
                                          <g data-name="Raggruppa 4">
                                            <g data-name="Raggruppa 3">
                                              <path
                                                data-name="Tracciato 2"
                                                d="M355.148 234.386h-198.3a19.83 19.83 0 000 39.66h198.3a19.83 19.83 0 000-39.66z"
                                              />
                                            </g>
                                          </g>
                                        </svg>
                                      </button>
                                      <span
                                        class="inline-flex items-center px-2 text-sm rounded-md"
                                      >
                                        {{ dish.quantity }}
                                      </span>
                                      <button @click="addQuantity(dish)">
                                        <svg
                                          class="w-6 h-6 fill-current "
                                          :class="'text-' + $store.state.color.primary
                                          "
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 512 512"
                                        >
                                          <path
                                            d="M256 0C114.833 0 0 114.833 0 256s114.833 256 256 256 256-114.853 256-256S397.167 0 256 0zm0 472.341c-119.275 0-216.341-97.046-216.341-216.341S136.725 39.659 256 39.659 472.341 136.705 472.341 256 375.295 472.341 256 472.341z"
                                          />
                                          <path
                                            d="M355.148 234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83 8.884-19.83 19.83v79.318h-79.318c-10.966 0-19.83 8.884-19.83 19.83s8.864 19.83 19.83 19.83h79.318v79.318c0 10.946 8.864 19.83 19.83 19.83s19.83-8.884 19.83-19.83v-79.318h79.318c10.966 0 19.83-8.884 19.83-19.83s-8.864-19.83-19.83-19.83z"
                                          />
                                        </svg>
                                      </button>

                                      <button
                                        class="ml-4"
                                        @click="toogleNote(dish)"
                                      >
                                        <svg
                                          class="w-6 h-6 text-gray-600 fill-current "
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 24 24"
                                          width="24"
                                          height="24"
                                        >
                                          <path
                                            class="heroicon-ui"
                                            d="M8 4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h2zm0 2H6v14h12V6h-2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zm2-2v2h4V4h-4z"
                                          />
                                        </svg>
                                      </button>
                                    </div>

                                    <div
                                      v-if="
                                        dish.price != null &&
                                          dish.price != undefined &&
                                          dish.price != '' &&
                                          dish.hide_price == 0
                                      "
                                      class="text-xs font-medium leading-5"
                                    >
                                      <span
                                        class="inline-flex items-center px-2 rounded-md"
                                        :class="'text-' +
                                            $store.state.color.primary +
                                            ' bg-' +
                                            $store.state.color.secondary
                                        "
                                      >
                                        {{ dish.price.toFixed(2) }}
                                        {{ dish.unit }}
                                      </span>
                                      x {{ dish.quantity }}
                                    </div>
                                  </div>

                                  <div v-if="dish.showNote">
                                    <div
                                      class="relative mt-1 rounded-md shadow-sm"
                                    >
                                      <input
                                        @input="commentHandler($event, dish)"
                                        class="block w-full my-2 text-sm form-input"
                                        :placeholder="$t('cart.item_comment')"
                                        :value="
                                          dish.note && dish.note != ''
                                            ? dish.note
                                            : ''
                                        "
                                      />
                                    </div>
                                  </div>

                                  <p
                                    class="m-1 text-xs text-right"
                                    v-if="
                                      dish.unit != '€' &&
                                        dish.unit != '€/calice' &&
                                        dish.hide_price == 0
                                    "
                                  >
                                    {{ $t("cart.alert_price_variable") }}
                                    {{ dish.unit }}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div>
                              <p
                                v-if="countDishNoPrice == 0"
                                class="text-right"
                              >
                                <span v-if="total > 0">
                                  {{ $t("cart.total") }}:
                                  {{ total.toFixed(2) }}€
                                </span>
                              </p>
                              <p v-else>
                                <span
                                  v-show="
                                    $store.state.userShowMenuHotel == 0 ||
                                      $store.state.userShowMenuHotel == 2
                                  "
                                >
                                  {{ $t("cart.cant_calculate_total") }}
                                </span>
                              </p>
                            </div>

                            <div v-if="avaibleOrderTypes.length > 0">
                              <label
                                for="general_note"
                                class="block text-sm font-medium leading-5 text-gray-900"
                              >
                                {{ $t("cart.note") }}
                              </label>
                              <div class="relative rounded-md shadow-sm">
                                <textarea
                                  v-model="general_note"
                                  id="general_note"
                                  rows="3"
                                  class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                                ></textarea>
                              </div>
                            </div>
                          </div>

                          <div
                            class="flex-shrink-0 px-4 pt-6 border-t border-gray-200 sm:px-6"
                            v-if="avaibleOrderTypes.length > 0"
                          >
                            <div class="flex justify-end space-x-3">
                              <span class="inline-flex rounded-md shadow-sm">
                                <button
                                  @click="goToStep(2)"
                                  :class="' text-' +
                                      $store.state.color.secondary +
                                      ' bg-' +
                                      $store.state.color.primary
                                  "
                                  class="inline-flex items-center px-4 py-2 text-base font-medium leading-6 transition duration-150 ease-in-out border border-transparent rounded-md focus:outline-none focus:shadow-outline-indigo"
                                >
                                  {{ $t("cart.complete_order") }}
                                </button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </transition>
                </div>
              </div>
            </transition>
            <p class="block py-6 text-center ">
              <span class="text-sm">Powered by </span>
              <a
                class="font-bold text-indigo-700"
                target="_blank"
                href="https://www.menubyte.it"
                >menuByte.it</a
              >
            </p>
          </main>
        </div>
      </div>
    </div>
    <div
      style="display: none;"
      class="text-black text-gray-200 text-gray-600 text-red-100 text-red-600 text-orange-100 text-orange-600 text-yellow-100 text-yellow-500 text-green-100 text-green-600 text-teal-100 text-teal-600 text-blue-100 text-blue-600 text-indigo-100 text-indigo-600 text-purple-100 text-purple-600 text-pink-100 text-pink-600 bg-black bg-gray-200 bg-gray-600 bg-red-100 bg-red-600 bg-orange-100 bg-orange-600 bg-yellow-100 bg-yellow-500 bg-green-100 bg-green-600 bg-teal-100 bg-teal-600 bg-blue-100 bg-blue-600 bg-indigo-100 bg-indigo-600 bg-purple-100 bg-purple-600 bg-pink-100 bg-pink-600"
    ></div>

    <modal
      v-show="modal.show"
      :event="modal.event"
      :icon="modal.icon"
      :buttonText="modal.buttonText"
      :buttonClass="modal.buttonClass"
      :eventclose="modal.eventclose"
      :title="modal.title"
      :description="modal.description"
    ></modal>
    <Spinner v-show="spinner"></Spinner>
  </div>
</template>

<script>
import Translations from "../../apis/Translations";
import Newsletter from "../../apis/Newsletter";
import Order from "../../apis/Order";
import Modal from "./../../components/Modal";
import Spinner from "./../../components/Spinner";
//import WebFontLoader from 'webfontloader';
import vClickOutside from "v-click-outside";
import { mapGetters, mapActions, mapState } from "vuex";
import IconService from "../../apis/IconService";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/it";
import isMobile from "ismobilejs";
import { format } from "date-fns";
import addDays from "date-fns/addDays";

export default {
  metaInfo() {
    return {
      title: this.locationname,
      titleTemplate: "%s - menuByte.it",
    };
  },
  components: {
    DatePicker,
    Modal,
    Spinner,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      spinOn: false,
      isDisabled: false,
      isOpenMobile: false,
      isOpenLang: false,
      logourl: "",
      /*fontFamily: "'Metal Mania', cursive",*/
      fontWeight: "800",
      privacy: "",
      slideVisible: false,
      formNewsletter: {
        email: "",
        privacy: 0,
        uuid: "",
        locale: "",
      },
      formNewsletterResponse: "",
      locationname: "",
      orderStep: 1,
      selectedOrderType: null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      delivery: {
        date: new Date(),
        time_slot: new Date(),
        disableDays: 7,
        delivery_note: "",
        errors: {},
      },
      takeaway: {},
      hotel: {},
      table: {},
      umbrella: {},
      roomservice: {
        selectedOrderHour: false,
      },
      general_note: "",
      modal: {
        type: "",
        show: false,
        title: "",
        description: "",
        event: "",
        eventclose: "",
        icon: "",
        buttonText: "",
        buttonClass: "",
      },
    };
  },
  watch: {
    $route() {
      this.isOpenMobile = false;
      this.isOpenLang = false;
    },
  },
  computed: {
    ...mapState(["spinner"]),
    ...mapGetters("cart", {
      dishes: "cartProducts",
      total: "cartTotalPrice",
      countDishNoPrice: "countDishNoPrice",
      countDish: "countDish",
    }),
    dishesGrouppedByMenu() {
      /*
      let orderDishes = this.dishes.sort(function(a, b) {
        return a.incremental - b.incremental;
      });
      */

      /*
      let order = [...this.dishes].sort(
        (a, b) => a.incremental - b.incremental
      );
      */

      let group = this.dishes.reduce((r, a) => {
        let currentDishes = [];
        let menuDetail = null;
        let key = a.menuposition * 10000 + a.menuid;

        if (this.$store.state.userShowMenuHotel == 1) {
          key = a.menu_type_id;
        }

        if (r[key] != undefined && r[key].dishes != undefined) {
          currentDishes = [...r[key].dishes, a];
        } else {
          currentDishes.push(a);
        }

        if (this.$store.state.userShowMenuHotel == 1) {
          let menu = this.$store.state.location.menus.find(
            (x) => x.id == a.menuid
          );
          let reservationType = menu.schedule.reservationType;
          let startTime = menu.schedule.startTime;
          let endTime = menu.schedule.endTime;
          let now = new Date();

          if (
            reservationType === 0 &&
            (startTime < endTime ||
              (startTime > endTime &&
                now.getHours() >= startTime &&
                now.getHours() < 24))
          ) {
            now = addDays(now, 1);
          }

          menuDetail = {
            menuname: this.$t(
              "menu_types." +
                this.$store.state.location.avaible_menu_types.find(
                  (x) => x.id == a.menu_type_id
                ).slug
            ),
            menudate: format(now, "dd/MM/yyyy"),
          };
        } else {
          menuDetail = {
            menuname: a.menuname,
          };
        }

        r[key] = {
          dishes: currentDishes,
          menu: menuDetail,
        };
        return r;
      }, {});

      // 30 > 0
      //1 1
      //10 2
      return group;
      /*
      let group = this.dishes.reduce((r, a) => {
      r[a.menuid] = [...r[a.menuid] || [], a];
      return r;
      }, {});
      return group;
      */
    },
    avaibleOrderTypes() {
      //console.log(this.$store.state.userShowMenuHotel);
      if (this.$store.state.userShowMenuHotel == 1) {
        return this.$store.state.location.avaibleOrderTypes.filter(
          (item) =>
            item.enable == 1 && item.order_type[0].slug == "tavolo-hotel"
        );
      } else if (this.$store.state.userShowMenuHotel == 2) {
        return this.$store.state.location.avaibleOrderTypes.filter(
          (item) => item.enable == 1 && item.order_type[0].slug == "roomservice"
        );
      } else {
        return this.$store.state.location.avaibleOrderTypes.filter(
          (item) =>
            item.enable == 1 &&
            item.order_type[0].slug != "tavolo-hotel" &&
            item.order_type[0].slug != "roomservice"
        );
      }
    },
    languages() {
      return this.$store.state.location.languages_actives;
      //return Translations.getListLanguages(this.$store.state.location.languages, this.$store.state.location.languages_actives);
    },
    cssProps() {
      return {
        "font-family": this.fontFamily,
        "font-weight": this.fontWeight,
      };
    },
    /**style="font-family: 'Roboto'" */
    /* ... mapState('test',['locations']),*/
  },
  methods: {
    ...mapActions("cart", [
      "addQuantity",
      "removeQuantity",
      "setItems",
      "setCountDishNoPrice",
      "setCountDish",
    ]),
    gabibbo(min) {
      console.log(min);
    },
    createWhatsAppMessage(phone) {
      let dynamicText = "";
      if (this.selectedOrderType == "umbrella") {
        dynamicText = "dall'ombrellone " + this.delivery.table_name + ": ";
      }

      if (this.selectedOrderType == "roomservice") {
        dynamicText =
          "dalla camera " +
          this.delivery.room +
          " per il giorno " +
          format(this.delivery.date, "dd/MM/yyyy") +
          " alle ore " +
          format(this.delivery.time_slot, "HH:mm") +
          " : ";
      }

      let sms = "Ordinazione " + dynamicText;
      let arrayDish = [];
      for (let i = 0; i < this.dishes.length; i++) {
        let dish = this.dishes[i];
        let dishName = this.get(
          dish.translations,
          this.$store.state.locale,
          "name"
        );
        let dishNote = dish.note != "" ? "(" + dish.note + ")" : "";
        arrayDish.push(dish.quantity + " x " + dishName + dishNote);
      }
      sms += " " + arrayDish.join(",");

      if (this.general_note != "") {
        sms += ". NOTE: " + this.general_note;
      }

      let apilink = "https://";
      apilink += this.isMobile() ? "api" : "web";
      apilink +=
        ".whatsapp.com/send?phone=" + phone + "&text=" + encodeURI(sms);
      console.log(apilink);
      window.open(apilink, "_blank");
    },
    getRandomIntInclusive(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min; //Il max è incluso e il min è incluso
    },

    toggleSlide() {
      this.slideVisible = !this.slideVisible;
    },

    submitDeliveryOrder() {
      let failed = false;

      this.delivery.errors = {};

      if (
        this.selectedOrderType == "domicilio" ||
        this.selectedOrderType == "asporto"
      ) {
        if (
          this.delivery.date == null ||
          this.delivery.date == undefined ||
          this.delivery.date == ""
        ) {
          this.delivery.errors = {
            ...this.delivery.errors,
            ...{
              date: ["Data ordine richiesta"],
            },
          };
          failed = true;
        }

        if (
          this.delivery.time_slot == null ||
          this.delivery.time_slot == undefined ||
          this.delivery.time_slot == ""
        ) {
          this.delivery.errors = {
            ...this.delivery.errors,
            ...{
              time_slot: ["Orario richiesto"],
            },
          };
          failed = true;
        }

        if (
          this.delivery.name == null ||
          this.delivery.name == undefined ||
          this.delivery.name == ""
        ) {
          this.delivery.errors = {
            ...this.delivery.errors,
            ...{
              name: ["Nome richiesto"],
            },
          };
          failed = true;
        }

        if (
          this.delivery.surname == null ||
          this.delivery.surname == undefined ||
          this.delivery.surname == ""
        ) {
          this.delivery.errors = {
            ...this.delivery.errors,
            ...{
              surname: ["Cognome richiesto"],
            },
          };
          failed = true;
        }

        if (
          this.delivery.phone == null ||
          this.delivery.phone == undefined ||
          this.delivery.phone == ""
        ) {
          this.delivery.errors = {
            ...this.delivery.errors,
            ...{
              phone: ["Telefono richiesto"],
            },
          };
          failed = true;
        }

        if (
          this.delivery.email == null ||
          this.delivery.email == undefined ||
          this.delivery.email == ""
        ) {
          this.delivery.errors = {
            ...this.delivery.errors,
            ...{
              email: ["Email richiesta"],
            },
          };
          failed = true;
        }

        if (this.selectedOrderType == "domicilio") {
          if (
            this.delivery.city == null ||
            this.delivery.city == undefined ||
            this.delivery.city == ""
          ) {
            this.delivery.errors = {
              ...this.delivery.errors,
              ...{
                city: ["Comune richiesto"],
              },
            };
            failed = true;
          }

          if (
            this.delivery.zip == null ||
            this.delivery.zip == undefined ||
            this.delivery.zip == ""
          ) {
            this.delivery.errors = {
              ...this.delivery.errors,
              ...{
                zip: ["Cap richiesto"],
              },
            };
            failed = true;
          }

          if (
            this.delivery.street == null ||
            this.delivery.street == undefined ||
            this.delivery.street == ""
          ) {
            this.delivery.errors = {
              ...this.delivery.errors,
              ...{
                street: ["Via richiesta"],
              },
            };
            failed = true;
          }

          if (
            this.delivery.house_number == null ||
            this.delivery.house_number == undefined ||
            this.delivery.house_number == ""
          ) {
            this.delivery.errors = {
              ...this.delivery.errors,
              ...{
                house_number: ["Civico richiesto"],
              },
            };
            failed = true;
          }
        }

        if (failed == false) {
          let form = {
            uuid: this.$store.state.location.uuid,
            order_type: this.selectedOrderType,
            order_date:
              format(this.delivery.date, "yyyy-MM-dd") +
              " " +
              format(this.delivery.time_slot, "HH:mm"),
            name: this.delivery.name,
            surname: this.delivery.surname,
            phone: this.delivery.phone,
            email: this.delivery.email,
            city: this.delivery.city,
            zip: this.delivery.zip,
            street: this.delivery.street,
            house_number: this.delivery.house_number,
            delivery_note: this.delivery.delivery_note,
            note: this.general_note,
            cart: this.dishes,
          };

          //whatsapp
          let selectedSource = null;
          let phone = null;
          this.$store.state.location.avaibleOrderTypes.forEach((element) => {
            if (element.order_type[0].slug == this.selectedOrderType) {
              selectedSource = element.settings.selectedSource;
              if (selectedSource == "whatsapp") {
                phone = element.settings.whatsapp;
              }
            }
          });

          if (selectedSource == "whatsapp") {
            /*

        */
            let sms =
              "Buongiorno, sono  " +
              this.delivery.name +
              " " +
              this.delivery.surname +
              " vorrei ordinare per il giorno " +
              format(this.delivery.date, "dd/MM/yyyy") +
              " alle ore " +
              format(this.delivery.time_slot, "HH:mm") +
              " i seguenti piatti:";
            let arrayDish = [];
            for (let i = 0; i < this.dishes.length; i++) {
              let dish = this.dishes[i];
              let dishName = this.get(
                dish.translations,
                this.$store.state.locale,
                "name"
              );
              let dishNote = dish.note != "" ? "(" + dish.note + ")" : "";
              arrayDish.push(dish.quantity + " x " + dishName + dishNote);
            }
            sms += " " + arrayDish.join(",");

            if (this.selectedOrderType == "domicilio") {
              sms +=
                ". Da consegnare a " +
                this.delivery.city +
                " " +
                this.delivery.zip +
                " " +
                " all'indirizzo " +
                this.delivery.street +
                " " +
                this.delivery.house_number;
              let deliveryNote =
                this.delivery.delivery_note != ""
                  ? this.delivery.delivery_note
                  : "";
              sms += deliveryNote;
            }

            if (this.selectedOrderType == "asporto") {
              sms += ". Tipologia di ordine: ASPORTO";
            }

            if (this.general_note != "") {
              sms += ". NOTE: " + this.general_note;
            }

            sms +=
              ". Telefono: " +
              this.delivery.phone +
              " Email:" +
              this.delivery.email;

            let apilink = "https://";
            apilink += this.isMobile() ? "api" : "web";
            apilink +=
              ".whatsapp.com/send?phone=" + phone + "&text=" + encodeURI(sms);
            //console.log(apilink)
            window.open(apilink, "_blank");
          } else if (selectedSource == "menubyte") {
            this.spinOn = true;
            this.isDisabled = true;
            Order.submit(form)
              .then((response) => {
                this.spinOn = false;
                this.isDisabled = false;
                this.selectedOrderType = null;
                this.setItems([]);
                this.setCountDishNoPrice(0);
                this.setCountDish(0);
                this.toogleSlide();

                this.modal.eventclose = "clickCloseModal";
                this.modal.title = this.$t("modalorder.wait_approvation");
                this.modal.description = this.$t(
                  "modalorder.success_takeaway_delivery"
                );
                this.modal.icon = "party";
                this.modal.show = true;

                this.$root.$on("clickCloseModal", () => {
                  this.modal.show = false;
                });

                console.log(response);
              })
              .catch((error) => {
                if (error.response.status === 422) {
                  this.delivery.errors = error.response.data.errors;
                } else {
                  this.modal.eventclose = "clickCloseModal";
                  this.modal.title = this.$t("modalorder.unsuccess");
                  this.modal.description = this.$t(
                    "modalorder.unsoccess_descr"
                  );
                  this.modal.icon = "alert";
                  this.modal.show = true;

                  this.$root.$on("clickCloseModal", () => {
                    this.modal.show = false;
                  });
                }
                this.spinOn = false;
                this.isDisabled = false;
              });
          }
        }
      }

      if (
        this.selectedOrderType == "tavolo" ||
        this.selectedOrderType == "umbrella"
      ) {
        let selectedSource = null;
        let phone = null;
        let password = null;
        this.$store.state.location.avaibleOrderTypes.forEach((element) => {
          if (element.order_type[0].slug == this.selectedOrderType) {
            selectedSource = element.settings.selectedSource;
            if (selectedSource == "whatsapp") {
              password = element.settings.password;
              phone = element.settings.whatsapp;
            }
          }
        });

        if (
          this.delivery.table_name == null ||
          this.delivery.table_name == undefined ||
          this.delivery.table_name == ""
        ) {
          if (this.selectedOrderType == "umbrella") {
            this.delivery.errors = {
              ...this.delivery.errors,
              ...{
                table_name: ["Numero ombrellone obbligatorio"],
              },
            };
          } else {
            this.delivery.errors = {
              ...this.delivery.errors,
              ...{
                table_name: ["Numero ombrellone obbligatorio"],
              },
            };
          }
          failed = true;
        }

        if (selectedSource == "whatsapp") {
          if (
            password != null &&
            password != "" &&
            (this.delivery.password == null || this.delivery.password == "")
          ) {
            this.delivery.errors = {
              ...this.delivery.errors,
              ...{
                date: ["Password richiesta"],
              },
            };
            failed = true;
          }

          if (
            password != null &&
            password != "" &&
            this.delivery.password != null &&
            this.delivery.password != "" &&
            this.delivery.password != password
          ) {
            this.delivery.errors = {
              ...this.delivery.errors,
              ...{
                date: ["Password non valida"],
              },
            };
            failed = true;
          }
        }

        if (failed == false) {
          /*
          let selectedSource = null;
          let phone = null;
          this.$store.state.location.avaibleOrderTypes.forEach((element) => {
            if (element.order_type[0].slug == this.selectedOrderType) {
              selectedSource = element.settings.selectedSource;
              if (selectedSource == "whatsapp") {
                phone = element.settings.whatsapp;
              }
            }
          });
          */

          if (
            this.selectedOrderType == "umbrella" &&
            selectedSource == "whatsapp"
          ) {
            this.createWhatsAppMessage(phone);
            console.log("whatsapp", phone);
          } else {
            let form = {
              uuid: this.$store.state.location.uuid,
              order_type: this.selectedOrderType,
              table_name: this.delivery.table_name,
              password: this.delivery.password,
              note: this.general_note,
              cart: this.dishes,
            };

            this.spinOn = true;
            this.isDisabled = true;
            Order.submit(form)
              .then((response) => {
                this.spinOn = false;
                this.isDisabled = false;
                this.selectedOrderType = null;
                this.setItems([]);
                this.setCountDishNoPrice(0);
                this.setCountDish(0);
                this.toogleSlide();

                this.modal.eventclose = "clickCloseModal";
                this.modal.title = this.$t("modalorder.success_title");
                this.modal.description = this.$t("modalorder.success_descr");
                this.modal.icon = "party";
                this.modal.show = true;

                this.$root.$on("clickCloseModal", () => {
                  this.modal.show = false;
                });

                console.log(response);
              })
              .catch((error) => {
                if (error.response.status === 422) {
                  this.delivery.errors = error.response.data.errors;
                } else {
                  this.modal.eventclose = "clickCloseModal";
                  this.modal.title = this.$t("modalorder.unsuccess");
                  this.modal.description = this.$t(
                    "modalorder.unsoccess_descr"
                  );
                  this.modal.icon = "alert";
                  this.modal.show = true;

                  this.$root.$on("clickCloseModal", () => {
                    this.modal.show = false;
                  });
                }
                this.spinOn = false;
                this.isDisabled = false;
              });
          }
        }
      }

      if (this.selectedOrderType == "roomservice") {
        let selectedSource = null;
        let phone = null;
        let password = null;
        this.$store.state.location.avaibleOrderTypes.forEach((element) => {
          if (element.order_type[0].slug == this.selectedOrderType) {
            selectedSource = element.settings.selectedSource;
            if (selectedSource == "whatsapp") {
              password = element.settings.password;
              phone = element.settings.whatsapp;
            }
          }
        });

        if (
          this.delivery.date == null ||
          this.delivery.date == undefined ||
          this.delivery.date == ""
        ) {
          this.delivery.errors = {
            ...this.delivery.errors,
            ...{
              date: ["Data ordine richiesta"],
            },
          };
          failed = true;
        }

        if (
          this.delivery.time_slot == null ||
          this.delivery.time_slot == undefined ||
          this.delivery.time_slot == ""
        ) {
          this.delivery.errors = {
            ...this.delivery.errors,
            ...{
              time_slot: ["Orario richiesto"],
            },
          };
          failed = true;
        }
        if (
          this.delivery.room == null ||
          this.delivery.room == undefined ||
          this.delivery.room == ""
        ) {
          this.delivery.errors = {
            ...this.delivery.errors,
            ...{
              table_name: ["Numero camera richiesto"],
            },
          };
          failed = true;
        }

        if (selectedSource == "whatsapp") {
          if (
            password != null &&
            password != "" &&
            (this.delivery.password == null || this.delivery.password == "")
          ) {
            this.delivery.errors = {
              ...this.delivery.errors,
              ...{
                date: ["Password richiesta"],
              },
            };
            failed = true;
          }

          if (
            password != null &&
            password != "" &&
            this.delivery.password != null &&
            this.delivery.password != "" &&
            this.delivery.password != password
          ) {
            this.delivery.errors = {
              ...this.delivery.errors,
              ...{
                date: ["Password non valida"],
              },
            };
            failed = true;
          }
        }

        if (failed == false) {
          if (selectedSource == "whatsapp") {
            this.createWhatsAppMessage(phone);
            console.log("whatsapp", phone);
          } else {
            let form = {
              uuid: this.$store.state.location.uuid,
              order_type: this.selectedOrderType,
              room: this.delivery.room,
              password: this.delivery.password,
              note: this.general_note,
              cart: this.dishes,
              order_date:
                format(this.delivery.date, "yyyy-MM-dd") +
                " " +
                format(this.delivery.time_slot, "HH:mm"),
            };

            this.spinOn = true;
            this.isDisabled = true;
            Order.submit(form)
              .then((response) => {
                this.spinOn = false;
                this.isDisabled = false;
                this.selectedOrderType = null;
                this.setItems([]);
                this.setCountDishNoPrice(0);
                this.setCountDish(0);
                this.toogleSlide();

                this.modal.eventclose = "clickCloseModal";
                this.modal.title = this.$t("modalorder.success_title");
                this.modal.description = this.$t("modalorder.success_descr");
                this.modal.icon = "party";
                this.modal.show = true;

                this.$root.$on("clickCloseModal", () => {
                  this.modal.show = false;
                });

                console.log(response);
              })
              .catch((error) => {
                if (error.response.status === 422) {
                  this.delivery.errors = error.response.data.errors;
                } else {
                  this.modal.eventclose = "clickCloseModal";
                  this.modal.title = this.$t("modalorder.unsuccess");
                  this.modal.description = this.$t(
                    "modalorder.unsoccess_descr"
                  );
                  this.modal.icon = "alert";
                  this.modal.show = true;

                  this.$root.$on("clickCloseModal", () => {
                    this.modal.show = false;
                  });
                }
                this.spinOn = false;
                this.isDisabled = false;
              });
          }
        }
      }

      if (this.selectedOrderType == "tavolo-hotel") {
        if (
          this.delivery.room == null ||
          this.delivery.room == undefined ||
          this.delivery.room == ""
        ) {
          this.delivery.errors = {
            ...this.delivery.errors,
            ...{
              room: ["Numero Camera"],
            },
          };
          failed = true;
        }

        if (failed == false) {
          let form = {
            uuid: this.$store.state.location.uuid,
            order_type: this.selectedOrderType,
            room: this.delivery.room,
            password: this.delivery.password,
            note: this.general_note,
            cart: this.dishes,
          };

          this.spinOn = true;
          this.isDisabled = true;
          Order.submit(form)
            .then((response) => {
              this.spinOn = false;
              this.isDisabled = false;
              this.selectedOrderType = null;
              this.setItems([]);
              this.setCountDishNoPrice(0);
              this.setCountDish(0);
              this.toogleSlide();

              this.modal.eventclose = "clickCloseModal";
              this.modal.title = this.$t("modalorder.success_title");
              this.modal.description = this.$t(
                "modalorder.success_hotel_descr"
              );
              this.modal.icon = "party";
              this.modal.show = true;

              this.$root.$on("clickCloseModal", () => {
                this.modal.show = false;
              });

              console.log(response);
            })
            .catch((error) => {
              if (error.response.status === 422) {
                this.delivery.errors = error.response.data.errors;
              } else {
                this.modal.eventclose = "clickCloseModal";
                this.modal.title = this.$t("modalorder.attention");
                let errorMessages = [];
                for (
                  let i = 0;
                  i < error.response.data.errorsmessage.length;
                  i++
                ) {
                  //Errore orario
                  if (error.response.data.errorsmessage[i].code == 1001) {
                    errorMessages.push(
                      this.$t(
                        "hotel.timeerror" +
                          error.response.data.errorsmessage[i].slug
                      )
                    );
                  }

                  if (error.response.data.errorsmessage[i].code == 1002) {
                    errorMessages.push(
                      "error" + error.response.data.errorsmessage[i].slug
                    );
                  }

                  if (error.response.data.errorsmessage[i].code == 1003) {
                    errorMessages.push(
                      this.$t(
                        "hotel.alreadyexist" +
                          error.response.data.errorsmessage[i].slug
                      )
                    );
                  }
                }

                this.modal.description = errorMessages.join("<br>");

                this.modal.icon = "alert";
                this.modal.show = true;

                this.$root.$on("clickCloseModal", () => {
                  this.modal.show = false;
                });
              }
              this.spinOn = false;
              this.isDisabled = false;
            });
        }
      }
    },
    getDayName(key) {
      if (key == "monday") return this.$t("days.monday");
      if (key == "tuesday") return this.$t("days.tuesday");
      if (key == "wednesday") return this.$t("days.wednesday");
      if (key == "thursday") return this.$t("days.thursday");
      if (key == "friday") return this.$t("days.friday");
      if (key == "saturday") return this.$t("days.saturday");
      if (key == "sunday") return this.$t("days.sunday");
    },
    getTimeSpan(day) {
      if (day.isOpen == false) return this.$t("closed");

      if (day.open == null || day.close == null) return "";

      let parsed = parseInt(day.open);
      let tempOpen;
      if (!isNaN(parsed)) {
        tempOpen = day.open.substring(0, 2) + ":" + day.open.substring(2, 4);
      } else {
        tempOpen = day.open;
      }

      let tempClose;
      parsed = parseInt(day.close);
      if (!isNaN(parsed)) {
        tempClose = day.close.substring(0, 2) + ":" + day.close.substring(2, 4);
      } else {
        tempClose = day.close;
      }

      return tempOpen + "-" + tempClose + " ";
    },
    disabledDateDelivery(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return (
        date < today ||
        date >
          new Date(
            today.getTime() + this.delivery.disableDays * 24 * 3600 * 1000 - 1
          )
      );
    },
    disabledDateTakeAway(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return (
        date < today ||
        date >
          new Date(
            today.getTime() + this.takeaway.disableDays * 24 * 3600 * 1000 - 1
          )
      );
    },

    disabledDateRoomService(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return (
        date < today ||
        date >
          new Date(
            today.getTime() +
              this.roomservice.disableDays * 24 * 3600 * 1000 -
              1
          )
      );
    },

    toogleNote(dish) {
      dish.showNote = !dish.showNote;
    },
    commentHandler(event, dish) {
      dish.note = event.target.value;
    },
    getLogo(url) {
      return IconService.getLogo(url);
    },
    toogleSlide() {
      if (!this.slideVisible) {
        this.orderStep = 1;
      }
      this.slideVisible = !this.slideVisible;
    },
    goToStep(step) {
      this.orderStep = step;
    },

    onSubmit: function() {
      Newsletter.subscribe(this.formNewsletter)
        .then((response) => {
          if (response.data.coupon != "") {
            this.formNewsletterResponse = this.$t("newsletter.thanks_copuon");
          } else {
            this.formNewsletterResponse = this.$t("newsletter.thanks");
          }
          this.formNewsletter.email = "";
          this.formNewsletter.privacy = 0;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.formErrors = error.response.data.errors;
          }
        });
    },
    setLang: function(locale) {
      this.isOpenLang = false;
      this.$store.dispatch("setLocale", locale);
      this.$i18n.locale = locale;
      this.privacy = this.getPrivacyPolicyLink();
    },
    changeLang() {
      this.setLang(this.locale);
    },
    setFontLoaded() {
      //alert("sss");
      //this.$emit('font-loaded');
    },
    onClickOutsideMobile() {
      this.isOpenMobile = false;
    },
    onClickOutsideLang() {
      this.isOpenLang = false;
    },
    toogleMobileMenu() {
      this.isOpenMobile = !this.isOpenMobile;
    },

    toogleLangMenu() {
      this.isOpenLang = !this.isOpenLang;
    },

    getPrivacyPolicyLink() {
      if (
        this.$store.state.location.privacy_policy &&
        this.$store.state.location.privacy_policy.translations
      ) {
        for (
          let i = 0;
          i < this.$store.state.location.privacy_policy.translations.length;
          i++
        ) {
          //console.log(this.$store.state.location.marketing_email_settings.translations[i].locale);
          if (
            this.$store.state.location.privacy_policy.translations[i].locale ==
            this.$store.state.locale
          ) {
            //console.log(this.$store.state.location.marketing_email_settings.translations[i].locale);
            return this.$store.state.location.privacy_policy.translations[i]
              .privacy_policy;
          }
        }
      }
      /*
       if(this.$store.state.location.marketing_email_settings && this.$store.state.location.marketing_email_settings.translations){
        for(let i = 0; i < this.$store.state.location.marketing_email_settings.translations.length; i++){
          //console.log(this.$store.state.location.marketing_email_settings.translations[i].locale);
          if(this.$store.state.location.marketing_email_settings.translations[i].locale == this.$store.state.locale){
            //console.log(this.$store.state.location.marketing_email_settings.translations[i].locale);
            return this.$store.state.location.marketing_email_settings.translations[i].privacy_policy;
          }
        }
      }
      */
    },

    get: function(translations, locale, prop) {
      return Translations.get(translations, locale, prop);
    },

    isMobile() {
      return isMobile(window.navigator).any;
    },
  },
  mounted: function() {
    this.$store.dispatch("setColor", this.$store.state.location.color);
    this.formNewsletter.uuid = this.$store.state.location.uuid;
    this.formNewsletter.locale = navigator.language || navigator.userLanguage;
    this.privacy = this.getPrivacyPolicyLink();
    this.locationname = this.$store.state.location.name;

    this.$store.state.location.avaibleOrderTypes.forEach((element) => {
      if (element.order_type[0].slug == "domicilio") {
        if (element.settings.selectedOrderToday == "no") {
          this.delivery.disableDays = 1;
        }
      }

      if (element.order_type[0].slug == "asporto") {
        if (element.settings.selectedOrderToday == "no") {
          this.takeaway.disableDays = 1;
        }
      }

      if (element.order_type[0].slug == "roomservice") {
        if (element.settings.selectedOrderHour == "yes") {
          this.roomservice.selectedOrderHour = true;
        }

        if (element.settings.selectedOrderToday == "no") {
          this.roomservice.disableDays = 1;
        } else {
          this.roomservice.disableDays = 2;
        }
      }

      if (element.order_type[0].slug == "tavolo") {
        if (
          element.settings.password != null &&
          element.settings.password != ""
        ) {
          this.table.requirePassword = true;
        } else {
          this.table.requirePassword = false;
        }
      }

      if (element.order_type[0].slug == "umbrella") {
        if (
          element.settings.password != null &&
          element.settings.password != ""
        ) {
          this.umbrella.requirePassword = true;
        } else {
          this.umbrella.requirePassword = false;
        }
      }

      if (element.order_type[0].slug == "roomservice") {
        if (
          element.settings.password != null &&
          element.settings.password != ""
        ) {
          this.roomservice.requirePassword = true;
        } else {
          this.roomservice.requirePassword = false;
        }
      }

      if (element.order_type[0].slug == "tavolo-hotel") {
        if (
          element.settings.password != null &&
          element.settings.password != ""
        ) {
          this.hotel.requirePassword = true;
        } else {
          this.hotel.requirePassword = false;
        }
      }
    });
  },
  created() {
    window.addEventListener("beforeunload", function(event) {
      event.returnValue = "sicuro di uscrire";
    });

    const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
      if (!this.slideVisible) {
        next(true);
      } else {
        this.slideVisible = false;
        next(false);
      }
    });

    this.$once("hook:destroyed", () => {
      unregisterRouterGuard();
    });
    /*
    WebFontLoader.load({
      google: {
      families: ['Metal Mania', 'Roboto']
      },
      active: this.setFontLoaded,
    });
    */
  },
};
</script>

<style>
.mx-datepicker {
  max-width: 100%;
}
.animate-spin {
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
}
@-webkit-keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.loader {
  border: 8px solid #f3f3f3;
  border-radius: 50%;
  border-top: 8px solid #5850ec;
  width: 50px;
  height: 50px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
</style>
